var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    { attrs: { "max-show-size": "xl" } },
    [
      _c(
        "app-toolbar",
        { attrs: { "drawer-button-disabled": "" } },
        [
          _c(
            "w-toolbar-text",
            {
              staticClass: "app-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { attrs: { grow: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", grow: "" } },
                [
                  _c(
                    "w-card",
                    { attrs: { grow: "" } },
                    [
                      _c(
                        "w-card-content",
                        { staticStyle: { "flex-grow": "1" } },
                        [
                          _c("app-product-edit-row", {
                            attrs: { "sale-edit-state": _vm.state },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }